// Created By Sanjay // 27-01-25
import { axiosGetAuthorize, axiosPostAuthorize, axiosGetMultiParams } from '../AxiosRequests';
import {
    USP_Master_CompanySelectbyID,
    USP_Master_ItemStockTransferNewYear,
    USP_Master_PartyBalanceTransferNewYear,
    USP_Master_BankClosingTransferNewYear,
    USP_TruncateAllRecords,
    USP_Master_CompanyUpdate,
    GetAllDropdownForEmployeeMaster,
    USP_Master_EmployeeInsertUpdate,
    USP_Master_EmployeeSelectbyID,
    GetAllDropdownForPartyMaster,
    USP_Master_PartyAccountInsertUpdate,
    USP_Master_PartyAccountSelected,
    GetMasterDropdownData,
    USP_Master_TaxStructureInsertUpdate,
    USP_Master_TaxStructureSelectbyID,
    USP_Master_DesignationInsertUpdate,
    USP_Master_DesignationSelectbyID,
    USP_Master_DepartmentInsertUpdate,
    USP_Master_DepartmentSelectbyID,
    USP_Master_EmployeeGroupInsertUpdate,
    USP_Master_EmployeeGroupSelectbyID,
    USP_Master_UnitInsertUpdate,
    USP_Master_UnitSelectbyID,
    USP_Master_ProductSizeInsertUpdate,
    USP_Master_ProductSizeSelectbyID,
    USP_Master_MaterialInsertUpdate,
    USP_Master_MaterialSelectbyId,
    USP_Master_PaymentModeInsertUpdate,
    USP_Master_PaymentModeSelectbyId,
    USP_Master_ProcessInsertUpdate,
    USP_Master_ProcessSelectbyID,
    USP_Master_PlantInsertUpdate,
    USP_Master_PlantSelectbyId,
    GetAllDropdownForStockMaster,
    USP_Master_ItemCategoryInsertUpdate,
    USP_Master_ItemCategorySelectbyID,
    USP_Master_ItemGroupInsertUpdate,
    USP_Master_ItemGroupSelectbyID,
    USP_Master_ItemCategorySelectbyItemType,
    USP_Master_ItemSelectForAutobyIdCategory,
    USP_Master_ItemInsertUpdate,
    USP_Master_ItemSelectbyID,
    USP_Master_ItemSelectbyItemType,
    USP_Master_ProductReceipeInsertUpdate,
    USP_Master_ProductReceipeSelectbyId,
    USP_Master_ItemSelectbyIDCategory,
    USP_Master_ProcessItemInsertUpdate,
    USP_Master_ProcessItemSelectbyID,
    USP_Master_ProcessItemListSelectbyID,
    USP_Master_ItemSelectForUpdatePlantWise,
    USP_Master_PlantItemDetailsInsert,
    USP_Master_PlantWiseItemSelect,
    USP_Master_ItemSelectForItemStock,
    USP_Master_ItemStockAdminApproved,
    USP_Master_ItemUpdateStock,
    USP_Master_ItemSelectForProcessRateRev,
    USP_Master_ItemRateProcesswiseInsert,
    USP_Master_ItemRateProcesswiseDelete,
    USP_Master_ItemSelectForRateRivision,
    USP_Master_ItemRateVendorwiseInsert,
    USP_Master_ItemRateVendorwiseSelect2,
    USP_Master_ItemRateVendorwiseUpdate,
    USP_Master_EmployeeSelect_ForPlant,
    USP_Master_EmployeePlantWiseInsert,
    USP_Master_ItemRateVendorwiseDelete2,
    Delete_Master_ItemsRecord,
    Delete_Master_ItemsExistingItemRecord,
    USP_Master_EmployeeSelect_ForProcess,
    USP_Master_EmployeeProcessWiseInsert,
    Usp_Master_PartyAccountSelectForVendors,
} from '../ApiEndPoints';

export default class MasterEntryServices {

    async getMasterCompanySelectbyID(request) {
        return axiosGetAuthorize(USP_Master_CompanySelectbyID, request);
    }
    async usp_Master_ItemStockTransferNewYear(request) {
        return axiosGetAuthorize(USP_Master_ItemStockTransferNewYear, request);
    }
    async usp_Master_PartyBalanceTransferNewYear(request) {
        return axiosPostAuthorize(USP_Master_PartyBalanceTransferNewYear, request);
    }
    async usp_Master_BankClosingTransferNewYear(request) {
        return axiosPostAuthorize(USP_Master_BankClosingTransferNewYear, request);
    }
    async usp_TruncateAllRecords(request) {
        return axiosGetAuthorize(USP_TruncateAllRecords, request);
    }
    async usp_Master_CompanyUpdate(request) {
        return axiosPostAuthorize(USP_Master_CompanyUpdate, request);
    }
    // async procItemStockRegister_TrackingDetails(request) {
    //     return axiosPostAuthorize(ProcItemStockRegister_TrackingDetails, request);
    // }

    async getAllDropdownForEmployeeMaster(request) {
        return axiosGetAuthorize(GetAllDropdownForEmployeeMaster, request);
    }
    async submitEmployeeMaster(request) {
        return axiosPostAuthorize(USP_Master_EmployeeInsertUpdate, request);
    }
    async getEmployeeMasterDetails(request) {
        return axiosGetAuthorize(USP_Master_EmployeeSelectbyID, request);
    }

    // Party Account Master 
    async getAllDropdownForPartyMaster(request) {
        return axiosGetAuthorize(GetAllDropdownForPartyMaster, request);
    }
    async submitPartyAccountInsertUpdate(request) {
        return axiosPostAuthorize(USP_Master_PartyAccountInsertUpdate, request);
    }
    async getPartyAccountSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_PartyAccountSelected, request);
    }

    // Tax structure master 
    async getMasterDropdownData(request) {
        return axiosPostAuthorize(GetMasterDropdownData, request);
    }
    async submitTaxStructureMaster(request) {
        return axiosPostAuthorize(USP_Master_TaxStructureInsertUpdate, request);
    }
    async getTaxStructureSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_TaxStructureSelectbyID, request);
    }

    // designation page 
    async submitDesignationMaster(request) {
        return axiosPostAuthorize(USP_Master_DesignationInsertUpdate, request);
    }
    async getMasterDesignationSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_DesignationSelectbyID, request);
    }

    // designation page 
    async submitDepartmentMaster(request) {
        return axiosPostAuthorize(USP_Master_DepartmentInsertUpdate, request);
    }
    async getMasterDepartmentSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_DepartmentSelectbyID, request);
    }

    // Employee Group master page 
    async submitEmployeeGroupMaster(request) {
        return axiosPostAuthorize(USP_Master_EmployeeGroupInsertUpdate, request);
    }
    async getMasterEmployeeGroupSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_EmployeeGroupSelectbyID, request);
    }

    // Unit master page 
    async submitUnitMaster(request) {
        return axiosPostAuthorize(USP_Master_UnitInsertUpdate, request);
    }
    async getMasterUnitSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_UnitSelectbyID, request);
    }

    // Product size master page 
    async submitProductSizeMaster(request) {
        return axiosPostAuthorize(USP_Master_ProductSizeInsertUpdate, request);
    }
    async getMasterProductSizeSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ProductSizeSelectbyID, request);
    }

    // Material master page 
    async submitMaterialMaster(request) {
        return axiosPostAuthorize(USP_Master_MaterialInsertUpdate, request);
    }
    async getMasterMaterialSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_MaterialSelectbyId, request);
    }

    // Payment mode master page 
    async submitPaymentModeMaster(request) {
        return axiosPostAuthorize(USP_Master_PaymentModeInsertUpdate, request);
    }
    async getMasterPaymentModeSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_PaymentModeSelectbyId, request);
    }

    // Process master page 
    async submitProcessMaster(request) {
        return axiosPostAuthorize(USP_Master_ProcessInsertUpdate, request);
    }
    async getMasterProcessSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ProcessSelectbyID, request);
    }

    // Plant master page 
    async submitPlantMaster(request) {
        return axiosPostAuthorize(USP_Master_PlantInsertUpdate, request);
    }
    async getMasterPlantSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_PlantSelectbyId, request);
    }

    async getAllDropdownForStockMaster(request) {
        return axiosGetAuthorize(GetAllDropdownForStockMaster, request);
    }

    // Item category master page 
    async submitItemCategorytMaster(request) {
        return axiosPostAuthorize(USP_Master_ItemCategoryInsertUpdate, request);
    }
    async getMasterItemCategorySelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ItemCategorySelectbyID, request);
    }

    // Item Group Master
    async submitItemGroupMaster(request) {
        return axiosPostAuthorize(USP_Master_ItemGroupInsertUpdate, request);
    }
    async getMasterItemGroupSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ItemGroupSelectbyID, request);
    }

    // Item master 
    async getMaster_ItemCategorySelectbyItemType(request) {
        return axiosGetMultiParams(USP_Master_ItemCategorySelectbyItemType, request);
    }
    async getMaster_ItemSelectForAutobyIdCategory(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectForAutobyIdCategory, request);
    }

    async submitItemMaster(request) {
        return axiosPostAuthorize(USP_Master_ItemInsertUpdate, request);
    }
    async getItemMasterSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ItemSelectbyID, request);
    }

    // Product BOM Setup
    async getMaster_ItemSelectbyItemType(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectbyItemType, request);
    }
    async submitProductReceipeItemMaster(request) {
        return axiosPostAuthorize(USP_Master_ProductReceipeInsertUpdate, request);
    }
    async getMaster_ProductReceipeSelectbyId(request) {
        return axiosGetAuthorize(USP_Master_ProductReceipeSelectbyId, request);
    }
    // async getMaster_ItemSelectbyID(request) {
    //     return axiosGetMultiParams(USP_Master_ItemSelectbyID, request);
    // }

    //// Item wise Process
    async getMasterItemSelectbyIDCategory(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectbyIDCategory, request);
    }
    async submitMasterProcessItem(request) {
        return axiosPostAuthorize(USP_Master_ProcessItemInsertUpdate, request);
    }
    async getMasterProcessItemSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ProcessItemSelectbyID, request);
    }
    async getMasterProcessItemListSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ProcessItemListSelectbyID, request);
    }

    // Plant wise 
    async getMasterItemSelectForUpdatePlantWise(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectForUpdatePlantWise, request);
    }
    async submitMasterPlantItemDetails(request) {
        return axiosPostAuthorize(USP_Master_PlantItemDetailsInsert, request);
    }
    async getMasterPlantWiseItemSelect(request) {
        return axiosGetMultiParams(USP_Master_PlantWiseItemSelect, request);
    }

    // Opening Stock
    async getMasterItemSelectForItemStock(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectForItemStock, request);
    }
    async masterItemStockAdminApproved(request) {
        return axiosPostAuthorize(USP_Master_ItemStockAdminApproved, request);
    }
    async saveAndUpdateStock(request) {
        return axiosPostAuthorize(USP_Master_ItemUpdateStock, request);
    }

    // Procces Rate Item Wise
    async getMasterItemSelectForProcessRateRev(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectForProcessRateRev, request);
    }
    async saveItemRateProcesswiseInsert(request) {
        return axiosPostAuthorize(USP_Master_ItemRateProcesswiseInsert, request);
    }
    async deleteItemRateProcesswise(request) {
        return axiosGetMultiParams(USP_Master_ItemRateProcesswiseDelete, request);
    }

    // Item Rate Vendor wise
    async getMasterItemSelectForRateRivision(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectForRateRivision, request);
    }
    async saveMasterItemRateVendorwiseInsert(request) {
        return axiosPostAuthorize(USP_Master_ItemRateVendorwiseInsert, request);
    }
    async getMasterItemRateVendorwiseSelect2(request) {
        return axiosGetAuthorize(USP_Master_ItemRateVendorwiseSelect2, request);
    }
    async saveMasterItemRateVendorwiseUpdate(request) {
        return axiosPostAuthorize(USP_Master_ItemRateVendorwiseUpdate, request);
    }
    async deleteItemRateVendorwiseDelete2(request) {
        return axiosGetAuthorize(USP_Master_ItemRateVendorwiseDelete2, request);
    }
    async delete_Master_ItemsRecord(request) {
        return axiosGetAuthorize(Delete_Master_ItemsRecord, request);
    }
    async deleteMasterItemsExistingItemRecord(request) {
        return axiosGetAuthorize(Delete_Master_ItemsExistingItemRecord, request);
    }
    async usp_Master_PartyAccountSelectForVendors(request) {
        return axiosGetMultiParams(Usp_Master_PartyAccountSelectForVendors, request);
    }

    // Employee Plant Wise 
    async getMasteEmployeeSelectForPlant(request) {
        return axiosGetMultiParams(USP_Master_EmployeeSelect_ForPlant, request);
    }
    async saveMasterEmployeePlantWiseInsert(request) {
        return axiosPostAuthorize(USP_Master_EmployeePlantWiseInsert, request);
    }

    // Employee Process Wise 
    async getMasteEmployeeSelectForProcess(request) {
        return axiosGetMultiParams(USP_Master_EmployeeSelect_ForProcess, request);
    }
    async saveMasterEmployeeProcessWiseInsert(request) {
        return axiosPostAuthorize(USP_Master_EmployeeProcessWiseInsert, request);
    }
}